import React, {
  DetailedHTMLProps,
  InputHTMLAttributes,
  RefObject,
} from "react";
import styled from "styled-components";

const StyledContainer = styled.label`
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 17px;
  cursor: pointer;
  font-size: 1.5rem;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  /* Hide the browser's default checkbox */

  & input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom checkbox */

  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 1.5rem;
    width: 1.5rem;
    border-radius: 0.2rem;
    border: 1px solid ${(props) => props.theme.colors.basic_black};

    &:after {
      content: "";
      position: absolute;
      display: none;
    }
  }

  /* On mouse-over, add a grey background color */

  &:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a blue background */

  & input:checked ~ .checkmark {
    //background-color: #2196f3;
  }

  /* Create the checkmark/indicator (hidden when not checked) */

  /* Show the checkmark when checked */

  & input:checked ~ .checkmark:after {
    display: block;
    content: "";
    position: absolute;
    width: 1.1rem;
    height: 1.1rem;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 1px;
    background-color: ${(props) => props.theme.colors.basic_black};
  }

  /* Style the checkmark/indicator */

  & .checkmark:after {
  }
`;

export const Checkbox = React.forwardRef(
  (
    props: DetailedHTMLProps<
      InputHTMLAttributes<HTMLInputElement>,
      HTMLInputElement
    >,
    ref
  ) => (
    <StyledContainer className="container">
      <input
        type="checkbox"
        ref={ref as RefObject<HTMLInputElement>}
        {...props}
      />
      <span className="checkmark" />
    </StyledContainer>
  )
);